import { useState } from 'react';
import { http } from './live-api';

/**
 * Новый пароль по ссылке из письма (/auth/reset#token=…). В дизайне прототипа такого экрана нет —
 * оформлен в стиле его экрана входа.
 */
export function ResetPassword() {
  const [token] = useState(() => {
    const t = new URLSearchParams(location.hash.slice(1)).get('token') ?? '';
    history.replaceState(null, '', '/auth/reset');
    return t;
  });
  const [pass, setPass] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (pass.length < 8) return setError('Пароль — не меньше 8 символов');
    setBusy(true);
    setError('');
    try {
      await http('/auth/password/reset', 'POST', { token, newPassword: pass });
      location.replace('/');
    } catch (err) {
      const x = err as { code?: string; message: string };
      setError(x.code === 'invalid_token' ? 'Ссылка устарела или уже использована — запросите новую' : x.message);
      setBusy(false);
    }
  };

  const field: React.CSSProperties = {
    height: 40,
    border: `1px solid ${error ? 'hsl(var(--destructive))' : 'hsl(var(--input))'}`,
    borderRadius: 10,
    padding: '0 12px',
    fontSize: 14,
    background: 'hsl(var(--background))',
    outline: 0,
    width: '100%',
    boxSizing: 'border-box',
  };
  return (
    <div
      data-theme="light"
      style={{
        minHeight: '100vh',
        background: 'hsl(var(--surface))',
        color: 'hsl(var(--foreground))',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        fontSize: 13,
      }}
    >
      <form
        onSubmit={submit}
        style={{ width: '100%', maxWidth: 380, display: 'flex', flexDirection: 'column', gap: 18 }}
      >
        <img src="/logo.svg" alt="socrat.dev" width={32} height={32} style={{ borderRadius: 9 }} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <h1 style={{ margin: 0, fontSize: 30, lineHeight: 1.1, fontWeight: 700, letterSpacing: '-0.025em' }}>
            Новый пароль
          </h1>
          <p style={{ margin: 0, fontSize: 14, lineHeight: 1.5, color: 'hsl(var(--muted-foreground))' }}>
            После смены пароля все остальные сеансы будут завершены.
          </p>
        </div>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 6, fontWeight: 600 }}>
          Пароль
          <div style={{ position: 'relative' }}>
            <input
              type={show ? 'text' : 'password'}
              value={pass}
              autoFocus
              placeholder="Не меньше 8 символов"
              onChange={(e) => setPass(e.target.value)}
              style={field}
            />
            <button
              type="button"
              onClick={() => setShow(!show)}
              aria-label="Показать пароль"
              style={{
                position: 'absolute',
                right: 8,
                top: 8,
                width: 24,
                height: 24,
                border: 0,
                background: 'transparent',
                cursor: 'pointer',
                color: 'hsl(var(--muted-foreground))',
              }}
            >
              <span
                style={{
                  display: 'block',
                  width: 16,
                  height: 16,
                  background: 'currentColor',
                  mask: `url(/icons/lucide/${show ? 'eye-off' : 'eye'}.svg) center/contain no-repeat`,
                }}
              />
            </button>
          </div>
          {error && <span style={{ fontWeight: 400, color: 'hsl(var(--destructive))' }}>{error}</span>}
        </label>
        <button
          type="submit"
          disabled={busy}
          style={{
            height: 40,
            border: 0,
            borderRadius: 10,
            background: 'hsl(var(--primary))',
            color: '#fff',
            fontWeight: 600,
            fontSize: 14,
            cursor: 'pointer',
            opacity: busy ? 0.7 : 1,
          }}
        >
          {busy ? 'Секунду…' : 'Сохранить и войти'}
        </button>
      </form>
    </div>
  );
}
